export type ChatToolContext = "companion" | "ile";
export type ToolId = "guidedLearning" | "quizMe" | "deepResearch" | "createImage";

export interface ToolOption {
  id: ToolId;
  label: string;
}

const DEFAULT_TOOLS: ToolOption[] = [
  { id: "guidedLearning", label: "Guided Learning" },
  { id: "quizMe", label: "Quiz Me" },
  { id: "deepResearch", label: "Deep Research" },
  { id: "createImage", label: "Create Image" },
];

const COMPANION_TOOLS: ToolOption[] = [{ id: "createImage", label: "Create Image" }];

export const TOOL_OPTIONS_BY_CHAT_TYPE: Record<ChatToolContext, ToolOption[]> = {
  companion: COMPANION_TOOLS,
  ile: DEFAULT_TOOLS,
};
